import InfiniteScroll from "react-infinite-scroll-component";
import { t } from "@/i18n-js/instance";
import { useNearMeFilter } from "@/react/components/shared/MemberFilters/SharedFilters/NearMe/useNearMeFilter";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import type { UseSelectMembersInfiniteQuery } from "../hooks/useSelectMembersInfiniteQuery";
import { MemberCardWithConnection } from "./MemberCardWithConnection";

interface CardViewProps {
  memberDataParams: UseSelectMembersInfiniteQuery;
}

export const CardView = ({ memberDataParams }: CardViewProps) => {
  const { members, fetchNextPage, hasNextPage, dataLength } = memberDataParams;

  const { nearMeFilter, isNearMeActive } = useNearMeFilter();

  return (
    <>
      {isNearMeActive && (
        <div className="mb-6">
          <Typography.LabelSm weight="medium">
            {t("member_directory.near_me.title", {
              count: dataLength,
            })}
          </Typography.LabelSm>
          <Typography.BodyXs>{nearMeFilter?.value?.name}</Typography.BodyXs>
        </div>
      )}
      <InfiniteScroll
        style={{ overflow: "initial" }}
        scrollThreshold={0.8}
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        loader={<Loader />}
        dataLength={members.length}
        scrollableTarget="panel"
      >
        <ol
          className="m-4 grid list-none auto-rows-fr grid-cols-[repeat(auto-fit,235px)] gap-5 md:m-0 lg:m-auto"
          data-testid="directory_members_grid w-[772px]"
        >
          {members.map(member => (
            <MemberCardWithConnection key={member.id} member={member} />
          ))}
        </ol>
      </InfiniteScroll>
    </>
  );
};
